import { render, staticRenderFns } from "./proof-of-deliveries.vue?vue&type=template&id=424a26c9&scoped=true"
import script from "./proof-of-deliveries.vue?vue&type=script&lang=js"
export * from "./proof-of-deliveries.vue?vue&type=script&lang=js"
import style0 from "./proof-of-deliveries.vue?vue&type=style&index=0&id=424a26c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a26c9",
  null
  
)

export default component.exports